import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
  template: `
    <ng-template>
      <ng-content></ng-content>
    </ng-template>
  `,
  selector: 'mui-carousel-slide'
})
export class MuiCarouselSlide {
  @Input() label: string | null = null;
  @ViewChild(TemplateRef, { static: true }) content!: TemplateRef<unknown>;
}
